// CMS Frontend Bundle
// This is a lightweight bundle for public-facing CMS pages
// It includes only the Stimulus controllers needed for forms

import { Application } from "@hotwired/stimulus"

// Initialize Stimulus
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import only the controllers needed for frontend
import CollectionFormController from "./controllers/collection_form_controller"

// Register controllers
application.register("collection-form", CollectionFormController)

// Export for potential external use
export { application }
